import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../app/api.service';

@Component({
	selector: 'component-tool',
	templateUrl: './component.tool.html',
	styleUrls: ['./component.tool.css']
})
export class ComponentTool implements OnInit, AfterViewInit {

	@Input() submitAt : string = "" //顾问第一次回答的时间
	@Input() context : string ="" //追问
	@Input() myData : any //我的作答数据
	@Input() studentData : any //我的作答数据
	@Input() constituteId : number
	@Input() tabNum :number
	@Input() studentList : any
	@Input() relationId : number
	@Input() relationIdArr :any
    @Input() appreciateCount : number  //点赞次数
	@Input() userClick : boolean
	@Input() showCount : boolean
	@Input() comment : any;//评论内容
	@Input() commentCount : number; //评论次数
	@Input() workSource : string;
	@Output() onShowToast = new EventEmitter<any>();
	@Output() ongetStudentAppreciate = new EventEmitter<any>();
	@Output() ongetMyAppreciate = new EventEmitter<any>();
    isFavour : boolean  //用户自己是否点赞
	data : any = {};
	learningPathId : any;
	courseId : any;
	isLastDay : any;
	isFirstDay : any;
	projectId : number;
	courseLearningPathMetaId : number;
	constructor(
		private route: ActivatedRoute,
		private  apiService: ApiService,
		private router: Router,) {
		}
    ngOnInit() {
		let submitAt= null;
		submitAt = this.submitAt && typeof(this.submitAt) != "undefined" ? this.submitAt.split('.')[0].split('T') : "";
		this.submitAt = submitAt ? submitAt[0] + " " + submitAt[1] : "";
		this.route.queryParams.subscribe(queryParams=>{
			this.learningPathId = queryParams['learningPathId'];
			this.courseId = queryParams['courseId'];
			this.isLastDay = !!queryParams['isLastDay'];
			this.isFirstDay = !!queryParams['firstDay'];
			this.projectId = queryParams['projectId'];
			this.courseLearningPathMetaId = queryParams['courseLearningPathMetaId'];
		})
	}

	ngAfterViewInit(){
		
	}
	//点赞
	favour(){
		if(this.tabNum == 0){
			this.data.relationId = this.myData.relationId;
			this.data.type = "appreciate";
			this.getAppreciate().then(result=>{
				if((!!result.some(item => item.userCampExerciseQuestionGroupMetasRelationId === this.myData.relationId) === false)){
					this.giveAppreciate(this.data).then(result=>{
						this.ongetMyAppreciate.emit();
					})
				}else{
					this.onShowToast.emit(true);
				}
			})
		}else if(this.tabNum == 1){
			this.data.relationId = this.relationId;
			this.data.type = "appreciate";
			//判断是否已经点过赞
			this.getAppreciate().then(result=>{
				//没点过
				if((!!result.some(item => item.userCampExerciseQuestionGroupMetasRelationId === this.relationId) === false)){
					this.giveAppreciate(this.data).then(result=>{
						this.ongetStudentAppreciate.emit({studentList:this.studentList,relationId:this.relationId});
					})
				}else{
					this.onShowToast.emit(true);
				}
			})
		}
    }
	//评论
	goComment(){
		if(this.isFirstDay){
			this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId,'constituteId': this.constituteId,'tabNum':this.tabNum,type:"comment",comment:this.comment,learningPathId:this.learningPathId,courseId:this.courseId,firstDay:1}});
		}else if(this.isLastDay){
			this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId,'constituteId': this.constituteId,'tabNum':this.tabNum,type:"comment",comment:this.comment,learningPathId:this.learningPathId,courseId:this.courseId,isLastDay:1}});
		}else{
			if(this.workSource == 'homework'){
				if(this.projectId){
					this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId,'constituteId': this.constituteId,'tabNum':this.tabNum,type:"comment",comment:this.comment,projectId:this.projectId,workSource:this.workSource}});
					}else if(this.courseLearningPathMetaId){
					this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId,'constituteId': this.constituteId,'tabNum':this.tabNum,type:"comment",comment:this.comment,courseLearningPathMetaId:this.courseLearningPathMetaId,workSource:this.workSource}});
					}
			}else{
				this.router.navigate(['learning-camp-request'], { queryParams: { 'relationId': this.relationId,'constituteId': this.constituteId,'tabNum':this.tabNum,type:"comment",comment:this.comment,learningPathId:this.learningPathId,courseId:this.courseId}});
			}
		}
	}

	//点赞
    giveAppreciate(data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/ddilearner/v2/camp/applicationPractice/saveOperationLog',
            'data':data
        }).toPromise();
    }

	//点赞列表
	getAppreciate() {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v2/camp/applicationPractice/getOperationLogList/3',
        }).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/component/tool/component.tool.ts